import React, { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Dialog } from 'components/Dialog'
import { GeometryTypes } from 'models/layer'
import { useFetchCustomLayer, useUpdateCustomLayer } from 'services/custom-layer'
import styles from './CustomLayerStylesDialog.module.scss'
import { CustomLayerPoint } from './components/CustomLayerPoint'
import { CustomLayerPolygon } from './components/CustomLayerPolygon'
import { CustomLayerLine } from './components/CustomLayerLine'
import { CustomLayerStyle } from 'models/custom-layer'
import { useUserContext } from 'context/user-context'

export const CustomLayerStylesDialog: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { layerId } = useParams()
  const [currentUser] = useUserContext()
  const { customLayer } = useFetchCustomLayer(layerId)

  const [updateCustomLayer, { status }] = useUpdateCustomLayer(layerId)

  const onClose = () => {
    navigate('/datasets')
  }

  const onFormSubmit = (viz: CustomLayerStyle) => {
    updateCustomLayer(
      { id_user: +currentUser?.id!, viz: JSON.stringify(viz) as any },
      {
        onSuccess: () => onClose(),
      },
    )
  }

  if (!customLayer) return null

  return (
    <Dialog
      aria-label={t('layer_style_dialog.title')}
      isOpen={true}
      onClose={onClose}
      className={styles.layerStyleDialog}
    >
      <Stack>
        <div>
          <Heading size="secondary">{t('layer_style_dialog.title')}</Heading>
          <Text>{t('layer_style_dialog.subtitle')}</Text>
        </div>
        {customLayer.geometryType === GeometryTypes.Point && (
          <CustomLayerPoint customLayer={customLayer} onSubmit={onFormSubmit} status={status} />
        )}
        {customLayer.geometryType === GeometryTypes.Polygon && (
          <CustomLayerPolygon customLayer={customLayer} onSubmit={onFormSubmit} status={status} />
        )}
        {customLayer.geometryType === GeometryTypes.Line && (
          <CustomLayerLine customLayer={customLayer} onSubmit={onFormSubmit} status={status} />
        )}
      </Stack>
    </Dialog>
  )
}

CustomLayerStylesDialog.displayName = 'CustomLayerStylesDialog'
